export default "__VITE_ASSET__my9TjcOy__"